module.exports = __webpack_public_path__ + "img/email.81378cb7.svg";